import { useEffect } from 'react';
import { useQuery } from 'convex/react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../../../backend/convex/_generated/api';
import { Header } from '../components/Header';
import { createBookUrl } from '../utils/slug';

export function Home() {
  const books = useQuery(api.books.list);
  const featuredBook = books?.[0];
  const navigate = useNavigate();

  useEffect(() => {
    if (!featuredBook) return;
    navigate(createBookUrl(featuredBook.title, featuredBook._id), { replace: true });
  }, [featuredBook, navigate]);

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] flex flex-col">
      <Header />

      {/* Content */}
      <main className="flex-1 flex flex-col items-center justify-center px-4">
        {!books ? (
          <div className="animate-pulse flex flex-col items-center">
            <div className="w-28 h-40 rounded-lg bg-[var(--bg-tertiary)] mb-6" />
            <div className="h-6 w-32 bg-[var(--bg-tertiary)] rounded mb-4" />
            <div className="h-4 w-48 bg-[var(--bg-tertiary)] rounded" />
          </div>
        ) : featuredBook ? (
          <div className="text-center max-w-sm">
            <div className="w-28 h-40 mx-auto mb-6 rounded-lg bg-gradient-to-br from-[var(--bg-tertiary)] to-[var(--bg-secondary)] border border-[var(--border)] overflow-hidden shadow-xl ring-1 ring-[var(--border)]">
              {featuredBook.coverUrl ? (
                <img src={featuredBook.coverUrl} alt={featuredBook.title} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-[var(--bg-tertiary)]">
                  <span className="font-body text-5xl text-[var(--text-tertiary)]">§</span>
                </div>
              )}
            </div>
            
            <h1 className="font-body text-2xl font-semibold text-[var(--text-primary)] mb-2">
              {featuredBook.title}
            </h1>
            
            <p className="font-ui text-sm text-[var(--text-secondary)] mb-6 line-clamp-2">
              {featuredBook.blurb || 'Read immersive fiction with optional audio moments. Unlock voicemails, calls, and confessions from characters you love.'}
            </p>

            <Link to={createBookUrl(featuredBook.title, featuredBook._id)} className="btn-primary text-sm">
              Start Reading
            </Link>
          </div>
        ) : (
          <div className="text-center max-w-sm">
            <div className="w-28 h-40 mx-auto mb-6 rounded-lg bg-gradient-to-br from-[var(--bg-tertiary)] to-[var(--bg-secondary)] border border-[var(--border)] flex items-center justify-center">
              <span className="font-body text-5xl text-[var(--text-tertiary)]">§</span>
            </div>
            
            <h1 className="font-body text-2xl font-semibold text-[var(--text-primary)] mb-2">
              Stories that speak
            </h1>
            
            <p className="font-ui text-sm text-[var(--text-secondary)] mb-6">
              Read immersive fiction with optional audio moments. Unlock voicemails, calls, and confessions from characters you love.
            </p>

            <div className="text-[var(--text-tertiary)] font-ui text-sm">
              No stories available yet.
            </div>
          </div>
        )}
      </main>

      {/* Footer */}
      <footer className="py-4 border-t border-[var(--border)]">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <p className="font-ui text-[11px] text-[var(--text-tertiary)]">
            © 2024 Lynder
          </p>
        </div>
      </footer>
    </div>
  );
}
